import React from 'react';
import { connect } from 'react-redux';
import { TextField, FormControl, FormHelperText } from '@mui/material';
import * as types from 'constants/actionTypes';
import { toMoney, toMoneyTyping } from 'library/moneyUtils';
import SecureComponent from '../SecureComponent';

class DecimalInputProductSKU extends SecureComponent {
    constructor(props) {
        super(props);
        if (props.value) {
            this.state = { ...this.state, value: props.value, productSupplier: props.productSupplier, error: "" };
        } else {
            this.state = { ...this.state, value: "", error: "" };
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value && newProps.value !== this.state.value) {
            this.setState({ value: newProps.value });
        } else if (!newProps.value) {
            this.setState({ value: "" });
        }

        if (newProps.productSupplier && newProps.productSupplier !== this.state.productSupplier) {
            this.setState({ productSupplier: newProps.productSupplier });
        } else if (!newProps.productSupplier) {
            this.setState({ value: [] });
        }

        if (newProps.error && newProps.error !== this.state.error) {
            this.setState({ error: newProps.error });
        } else if (!newProps.error) {
            this.setState({ error: "" });
        }
    }

    onChange = (event) => {
        // Input Value is string
        const value = event.target.value;
        console.log(value, typeof value);
        const maskedStringValue = toMoneyTyping(value);
        // // Change input string into Floating number
        const floatValue = parseFloat(maskedStringValue.replace(/,/g, '')) || 0;
        // console.log(floatValue, typeof floatValue);
        const min = parseFloat(this.props.min || 0);
        const max = parseFloat(this.props.max || 0);
        let finalFloatValue = floatValue;
        if (this.props.min && floatValue <= min) {
            finalFloatValue = min
        }
        if (this.props.max && floatValue >= max) {
            finalFloatValue = max;
        }
        const finalMaskedStringValue = toMoneyTyping((Math.round(finalFloatValue * 100 * 100) / 100));
        // console.log(finalMaskedStringValue, typeof finalMaskedStringValue);
        this.setState({ value: finalMaskedStringValue })
        this.updateStore(finalMaskedStringValue);

        if (this.props.onChange){
            this.props.onChange(event);
        }
    }

    onBlur = () => {
        const error = this.validate(this.state.value);
        this.setState({ error });
        this.updateStore(this.state.value);
    }

    updateStore(value) {
        const error = this.validate(value);
        this.setState({ ...this.state, error });

        if (value && this.state.productSupplier && this.state.productSupplier.length > 0){
            const checkName = this.props.name.replace("wholeSale", "")
            let updatedSupplier = this.state.productSupplier.find((item) => item.id === +checkName);
            updatedSupplier = {
                ...updatedSupplier,
                wholeSale: `${value}`
            }
            
            const supplierIndex = this.state.productSupplier.findIndex(item => item.id === +checkName);
            const updatedProductSupplier = this.state.productSupplier.map((supplier, index) =>
                index === supplierIndex ? updatedSupplier : supplier
            );

            this.setState({ 
                ...this.state, 
                productSupplier: updatedProductSupplier
            });
        
            this.props.dispatch({ type: types.FORM_INPUT, value, name: this.props.name });
            this.props.dispatch({ type: types.FORM_INPUT, name: "productSupplier", value: updatedProductSupplier });
            this.props.dispatch({ type: types.FORM_ERROR, name: this.props.name, error }); // Clear Redux error
        }else{
            this.props.dispatch({ type: types.FORM_INPUT, value: '', name: this.props.name });
        }
    }

    validate(value) {
        const p = this.props;
        let error = ``;
        if (!value && p.required) {
            error = p.errorMsg || `${p.name} is required`;
        }
        return error;
    }

    render() {
        const p = this.props;
        const s = this.state;
        const localError = s.error;
        const value = s.value;

        if (!s.authorized) return null;

        return (
            <div className={`form-group DecimalInput ${p.className || ``}`}>
                <FormControl
                    fullWidth
                    variant="standard"
                    error={Boolean(localError)}
                    id={p.name}
                    name={p.name}
                    className={`${p.className} ${Boolean(localError) ? 'error' : ''}`}
                >
                    <TextField
                        autoFocus={p.autoFocus}
                        name={p.name}
                        disabled={p.disabled}
                        value={value}
                        onChange={this.onChange}
                        onBlur={this.onBlur}
                        label={p.label || p.floatingLabelText}
                        InputProps={{ style: p.inputStyle }}
                        InputLabelProps={{ style: p.floatingLabelStyle }}
                        // helperText={p.hintText}
                        variant="standard"
                        placeholder={p.hintText}
                        error={Boolean(localError)}
                    />
                    {localError ? <FormHelperText>{localError}</FormHelperText> : null}
                </FormControl>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        value: state.form[props.name] || +props.value,
        error: state.form && state.form.error && state.form.error[props.name],
        productSupplier: state.form.productSupplier,
        userAutorizationLevel: state.common && state.common.user && state.common.user.authorizationLevel,
        poproductQuantity: state.form && state.form.productPOQuantity || 1
    };
};

export default connect(mapStateToProps)(DecimalInputProductSKU);
